import React from 'react';
import styled from 'styled-components';

interface TabBarProps {
  tabs: string[];
  activeTab: number;
  onTabChange: (index: number) => void;
}

const TabBarContainer = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
  background-color: #ffffff;
`;

const Tab = styled.button<{ $isActive: boolean }>`
  flex: 1;
  padding: 16px 8px;
  font-size: 14px;
  font-weight: ${props => props.$isActive ? '600' : '400'};
  color: ${props => props.$isActive ? '#262626' : '#b3b3b3'};
  background: none;
  border: none;
  border-bottom: ${props => props.$isActive ? '2px solid #262626' : '2px solid transparent'};
  cursor: pointer;
  transition: all 0.2s ease;
  
  
`;

const TabBar: React.FC<TabBarProps> = ({ tabs, activeTab, onTabChange }) => {
  return (
    <TabBarContainer>
      {tabs.map((tab, index) => (
        <Tab
          key={index}
          $isActive={activeTab === index}
          onClick={() => onTabChange(index)}
        >
          {tab}
        </Tab>
      ))}
    </TabBarContainer>
  );
};

export default TabBar;
